module.exports = __webpack_public_path__ + "static/media/2 (24).ced8b0a9.jpg";